import YandexCaptcha from './YandexCaptcha';

export default YandexCaptcha;
